import { useRef, useContext } from 'react'

import { KeyboardDatePicker } from '@material-ui/pickers'
import { makeStyles } from '@material-ui/core/styles'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendar } from '@fortawesome/pro-light-svg-icons'
import { get } from 'lodash'

import ContentModalContext from '../../../ContentModalProvider/Context'
import ValidationMessage from '../../../components/ValidationMessage'
import { FIELD_NAMES, ERROR_MESSAGES } from '../../../components/constants'
import { useOnUpdateDate } from './use-on-update'
import { getDateObjFromDateString, isValidDate, useDate } from './helpers'

const useStyles = makeStyles({
  picker: {
    margin: 0,
    width: '100%',
  },
  adornment: {
    textTransform: 'uppercase',
    marginRight: '-9px',
    marginLeft: 0,
  },
})

interface IDateSelectorProps {
  label: string
}

const id = 'college-content-edit-date'

const DateSelector = ({ label }: IDateSelectorProps) => {
  const classes = useStyles()
  const { item, validation, isEditing } = useContext(ContentModalContext)

  const date = useDate(item, FIELD_NAMES.DATE)
  const touchedRef = useRef(false)
  const touched = touchedRef.current || isEditing
  const onUpdateDate = useOnUpdateDate()
  return (
    <>
      <KeyboardDatePicker
        required
        fullWidth
        disableToolbar
        variant="inline"
        format="MM/dd/yyyy"
        margin="normal"
        keyboardIcon={
          <FontAwesomeIcon
            icon={faCalendar}
            size="xs"
          />
        }
        aria-describedby={id}
        label={label}
        inputProps={{
          placeholder: 'MM/DD/YYYY',
          onChange: (e) => {
            const v = get(e, 'target.value', '')
            const date = getDateObjFromDateString(v)
            if (date) {
              touchedRef.current = true
              onUpdateDate(date)
            }
          },
        }}
        value={date}
        className={classes.picker}
        inputVariant="outlined"
        onChange={(date: Date | null) => {
          if (isValidDate(date)) {
            touchedRef.current = true
            onUpdateDate(date)
          }
        }}
        InputAdornmentProps={{
          className: classes.adornment,
        }}
        InputLabelProps={{ shrink: true }}
        error={touched && validation.getHasError(FIELD_NAMES.DATE)}
      />
      <ValidationMessage
        id={id}
        label={FIELD_NAMES.DATE}
        valuesByError={{
          [ERROR_MESSAGES.REQUIRED]: date,
          [ERROR_MESSAGES.VALID_DATE]: date,
        }}
        touched={touched}
      />
    </>
  )
}

export default DateSelector
